import React from 'react'
import RowCell, { RowType } from 'scenes/Dashboard/components/RowCell'
import { EmailValidationStatus, Position } from 'scenes/Dashboard/data/people/types'

import { Typography } from '@mui/material'

function currentPositionParser(currentPositions: any[]): string {
  return currentPositions
    .reduce((result, position) => `${result}${position.organization.name} (${position.organization.domain})<br/>`, '')
    .replace(', ', '')
}

export const FirstNameCell = ({
  rowType,
  firstName,
  onClick,
}: {
  rowType: RowType
  firstName: string
  onClick?: () => void
}) => (
  <RowCell
    rowType={rowType}
    colSpan={4}
    onClick={onClick}
    centered
    contentByRowType={{
      [RowType.header]: 'First name',
      [RowType.default]: (
        <Typography variant="body2" noWrap>
          {firstName || '-'}
        </Typography>
      ),
    }}
  />
)

export const LastNameCell = ({
  rowType,
  lastName,
  onClick,
}: {
  rowType: RowType
  lastName: string
  onClick?: () => void
}) => (
  <RowCell
    rowType={rowType}
    colSpan={6}
    onClick={onClick}
    centered
    contentByRowType={{
      [RowType.header]: 'Last name',
      [RowType.default]: (
        <Typography variant="body2" noWrap>
          {lastName || '-'}
        </Typography>
      ),
    }}
  />
)

export const EmailCell = ({ rowType, email, onClick }: { rowType: RowType; email: string; onClick?: () => void }) => (
  <RowCell
    rowType={rowType}
    onClick={onClick}
    colSpan={6}
    contentByRowType={{
      [RowType.header]: 'Email',
      [RowType.default]: (
        <Typography variant="body2" noWrap>
          {email || '–'}
        </Typography>
      ),
    }}
  />
)

export const EmailValidationCell = ({
  rowType,
  emailValidationStatus,
  onClick,
}: {
  rowType: RowType
  emailValidationStatus: EmailValidationStatus
  onClick?: () => void
}) => (
  <RowCell
    rowType={rowType}
    onClick={onClick}
    colSpan={3}
    contentByRowType={{
      [RowType.header]: 'Email Validation',
      [RowType.default]: (
        <Typography variant="body2" noWrap>
          {emailValidationStatus || '–'}
        </Typography>
      ),
    }}
  />
)

export const LinkedinCell = ({
  rowType,
  linkedinUrl,
  onClick,
}: {
  rowType: RowType
  linkedinUrl: string
  onClick?: () => void
}) => (
  <RowCell
    rowType={rowType}
    onClick={onClick}
    colSpan={6}
    contentByRowType={{
      [RowType.header]: 'Linkedin URL',
      [RowType.default]: (
        <Typography variant="body2" noWrap>
          {linkedinUrl || '–'}
        </Typography>
      ),
    }}
  />
)

export const CurrentPositionsCell = ({
  rowType,
  currentPositions,
  onClick,
}: {
  rowType: RowType
  currentPositions: Position[]
  onClick?: () => void
}) => (
  <RowCell
    rowType={rowType}
    colSpan={6}
    onClick={onClick}
    contentByRowType={{
      [RowType.header]: 'Current Company',
      [RowType.default]: (
        <Typography
          variant="body2"
          noWrap
          dangerouslySetInnerHTML={{
            __html: currentPositions ? currentPositionParser(currentPositions) : '–',
          }}
        />
      ),
    }}
  />
)

export const GenderCell = ({
  rowType,
  gender,
  onClick,
}: {
  rowType: RowType
  gender: string
  onClick?: () => void
}) => (
  <RowCell
    rowType={rowType}
    colSpan={6}
    onClick={onClick}
    contentByRowType={{
      [RowType.header]: 'Gender',
      [RowType.default]: (
        <Typography variant="body2" noWrap>
          {gender || '–'}
        </Typography>
      ),
    }}
  />
)

export const BornOnCell = ({ rowType, bornOn, onClick }: { rowType: RowType; bornOn: Date; onClick?: () => void }) => (
  <RowCell
    rowType={rowType}
    colSpan={6}
    onClick={onClick}
    contentByRowType={{
      [RowType.header]: 'Born on',
      [RowType.default]: <Typography variant="body2">{bornOn ? bornOn.toString() : '–'}</Typography>,
    }}
  />
)

export const DiedOnCell = ({ rowType, diedOn, onClick }: { rowType: RowType; diedOn: Date; onClick?: () => void }) => (
  <RowCell
    rowType={rowType}
    colSpan={6}
    onClick={onClick}
    contentByRowType={{
      [RowType.header]: 'Died on',
      [RowType.default]: <Typography variant="body2">{diedOn ? diedOn.toString() : '–'}</Typography>,
    }}
  />
)
